var waitFor = require('../utils/waitFor');

waitFor('#tooling-table', function() {

  var dt = require( 'datatables.net' )( window, jQuery ),
    dt_fixedheader = require( 'datatables.net-fixedheader' )( window, jQuery ),
    dtUtils = require('../utils/dtUtils');


  // Results table
  var colData = [
    {
      title: 'Part Number',
      prop: 'partnumber',
      className: 'col-emphasize'
    },
    {
      title: 'RoHS 5/6 (< 4% lead)',
      prop: 'rohs',
      noSearch: true
    },
    {
      title: 'Contact Size',
      prop: 'contact_size',
      noSearch: true
    },
    {
      title: 'Strip Length',
      prop: 'strip_length',
      noSearch: true
    },
    {
      title: 'Handle & Positioner Kit Positronic P/N',
      prop: 'positioner_kit_positronic_pn',
      noSort: true
    },
    {
      title: 'Hand Crimp Tool Positronic P/N',
      prop: 'hand_crimp_tool_positronic_pn',
      noSort: true
    },
    {
      title: 'Hand Crimp Tool OEM P/N',
      prop: 'hand_crimp_tool_oem_pn',
      noSort: true
    },
    {
      title: 'Hand Crimp Tool Mil P/N',
      prop: 'hand_crimp_tool_mil_pn',
      noSort: true
    },
    {
      title: 'Positioner Positronic P/N',
      prop: 'positioner_positronic_pn',
      noSort: true
    },
    {
      title: 'Positioner OEM P/N',
      prop: 'positioner_oem_pn',
      noSort: true
    },
    {
      title: 'Positioner Mil P/N',
      prop: 'positioner_mil_pn',
      noSort: true
    },
    {
      title: 'Insertion Tool Positronic P/N',
      prop: 'insertion_tool_positronic_pn',
      noSort: true
    },
    {
      title: 'Insertion Tool OEM P/N',
      prop: 'insertion_tool_oem_pn',
      noSort: true
    },
    {
      title: 'Insertion Tool Mil P/N',
      prop: 'insertion_tool_mil_pn',
      noSort: true
    },
    {
      title: 'Removal Tool Positronic P/N',
      prop: 'removal_tool_positronic_pn',
      noSort: true
    },
    {
      title: 'Removal Tool OEM P/N',
      prop: 'removal_tool_oem_pn',
      noSort: true
    },
    {
      title: 'Removal Tool Mil P/N',
      prop: 'removal_tool_mil_pn',
      noSort: true
    }
  ];
  
  var dtOpts = {
    data: dtUtils.formatResultsData(window.toolingData, colData),
    columns: dtUtils.buildDataTablesColumns(colData),
    fixedHeader: true,
    searching: true,
    lengthChange: false,
    info: false,
    language: {
        search: "Search Part Number:"
    },
  };

  if(window.toolingData.length > 10)
    dtOpts.dom = 'f<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>';

  $('#tooling-table').DataTable(dtOpts);


});
